<template>
  <page-header-wrapper>
    <keep-alive :include="this.cachedViews">
      <router-view />
    </keep-alive>
  </page-header-wrapper>
</template>

<script>
import KeepAlive from "@/components/KeepAlive/index";
export default {
  name: 'PageView',
  components: {
    KeepAlive
  },
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    }
  }
}
</script>
